const students = [
  {
    id: 100000001,
    studentId: 100000001,
    firstName: 'أحمد',
    lastName: 'الزعبي',
    age: 14,
    grade: 'الثامن',
    class: '8B',
    gender: 'ذكر',
    fullName: 'أحمد الزعبي',
    address: 'عمان - الأردن',
    phone: '0791234567',
    guardianName: 'خالد الزعبي',
    guardianPhone: '0797654321',
    enrollmentDate: '2020-09-01',
    status: 'مسجل',
    isArchived: true,
    isBusJoined: true,
    finance: {
      balance: 150,
      lastPaymentDate: '2024-04-15',
      totalPaid: 3500,
    },
    history: [
      { date: '2020-09-01', event: 'تم تسجيل الطالب' },
      { date: '2021-06-30', event: 'تم ترقية الطالب إلى الصف الثامن' },
      { date: '2022-03-15', event: 'شارك في بطولة كرة القدم' },
    ],
  },
  {
    id: 100000002,
    studentId: 100000002,
    firstName: 'سارة',
    lastName: 'الخطيب',
    fullName: 'سارة الخطيب',
    age: 13,
    grade: 'السابع',
    class: '7A',
    gender: 'أنثى',
    address: 'الزرقاء - الأردن',
    phone: '0789876543',
    fullName: 'محمد الدسوقي',
    guardianName: 'ليلى الخطيب',
    guardianPhone: '0781234567',
    enrollmentDate: '2021-09-01',
    status: 'مسجل',
    isArchived: true,
    isBusJoined: false,
    finance: {
      balance: 0,
      lastPaymentDate: '2024-03-10',
      totalPaid: 4000,
    },
    history: [
      { date: '2021-09-01', event: 'تم تسجيل الطالبة' },
      { date: '2022-02-20', event: 'فازت بمسابقة الرسم' },
    ],
  },
  {
    id: 100000003,
    studentId: 100000003,
    firstName: 'محمد',
    lastName: 'الدسوقي',
    age: 15,
    grade: 'التاسع',
    fullName: 'محمد الدسوقي',
    class: '9C',
    gender: 'ذكر',
    address: 'إربد - الأردن',
    phone: '0776543210',
    guardianName: 'يوسف الدسوقي',
    guardianPhone: '0779876543',
    enrollmentDate: '2019-09-01',
    status: 'مسجل',
    isArchived: true,
    isBusJoined: true,
    finance: {
      balance: 200,
      lastPaymentDate: '2024-02-01',
      totalPaid: 3000,
    },
    history: [
      { date: '2019-09-01', event: 'تم تسجيل الطالب' },
      { date: '2020-05-25', event: 'شارك في معرض العلوم' },
      { date: '2021-07-01', event: 'تمت ترقيته إلى الصف التاسع' },
    ],
  },
  {
    id: 100000004,
    studentId: 100000004,
    firstName: 'محمد',
    lastName: 'الدسوقي',
    age: 15,
    grade: 'التاسع',
    class: '9C',
    gender: 'ذكر',
    address: 'إربد - الأردن',
    phone: '0776543210',
    guardianName: 'يوسف الدسوقي',
    guardianPhone: '0779876543',
    enrollmentDate: '2019-09-01',
    status: 'مسجل',
    isArchived: false,
    isBusJoined: true,
    finance: {
      balance: 200,
      lastPaymentDate: '2024-02-01',
      totalPaid: 3000,
    },
    history: [
      { date: '2019-09-01', event: 'تم تسجيل الطالب' },
      { date: '2020-05-25', event: 'شارك في معرض العلوم' },
      { date: '2021-07-01', event: 'تمت ترقيته إلى الصف التاسع' },
    ],
  },
];

export default students;
